
import barba from '@barba/core';
import Swiper from 'swiper';

export default class{

	constructor(){

        barba.hooks.beforeOnce((data) => {
            this.interviewSlider()
            this.blogSlider()

        })
        barba.hooks.after((data) => {
            this.interviewSlider()
            this.blogSlider()
        });
        
    }
    
    interviewSlider(){
        new Swiper('.c-interview__slider',{
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
            centeredSlides : true,
            speed:600,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: '.c-interview__slider .swiper-pagination',
                type: 'bullets',
            },
            breakpoints: {
                767: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                },
                1600: {
                    slidesPerView: 3,
                    spaceBetween: 60,
                }
            }
        })
    }
    
    blogSlider(){
        // const blog_thumbnails = document.querySelectorAll('.blog-slider-thumbnails a');
        const blogSlider = new Swiper('.js-blog__slider', {
            
            navigation:  {
                nextEl: '.js-blog__slider .swiper-button-next',
                prevEl: '.js-blog__slider .swiper-button-prev',
            },
            pagination: {
                el: '.js-blog__slider .swiper-pagination',
                type: 'fraction',
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' + ' / ' + '<span class="' + totalClass  + '"></span>';
                }
            },
            // on: {
            //     transitionStart(){
            //         const	self = this;
            //         for(let i = 0; i <  blog_thumbnails.length; i++){
            //             blog_thumbnails[i].classList.remove('active');
            //             blog_thumbnails[self.realIndex].classList.add('active');
            //         }
            //     }
            // },
            // preloadImages: false,
            // lazy: {
            //     loadPrevNext: true,
            // },
            loop : true
        });
        
        // const blogThumbnailAddEvent = (el,i) => {
        //     el.addEventListener('click',function(e){
        //         e.preventDefault();
        //         blogSlider.slideTo(i+1);
        //     })
        // }

        // for(var i = 0; i <  blog_thumbnails.length; i++){
        //     blogThumbnailAddEvent( blog_thumbnails[i],i);
        // }
    }
}